<template>
  <ion-page>
    <PageHeaderWithMenu title="Миксы" :scrolled="headerScrolled" />
    <ion-content class="main-background playlist-list-content" :fullscreen="true" slot="fixed" @ionScroll="onContentScroll">
      <ion-segment :value="selectedListSegment" @ionChange="listSegmentChange($event)" mode="md" class="custom-segment">
        <ion-segment-button value="all">
          <ion-label>Все</ion-label>
        </ion-segment-button>
        <ion-segment-button value="favourites">
          <ion-label>Избранное</ion-label>
        </ion-segment-button>
      </ion-segment>

      <ion-content class="bg-transparent" v-show="selectedListSegment == 'all'">
        <ion-accordion-group>
          <div v-for="(program, programIdx) in programs" :key="programIdx">
            <ion-accordion class="bg-transparent" :value="program.programName">
              <ion-item slot="header" class="program-item" lines="none" color="violet">
                <div class="program-img-wrapper">
                  <img :src="programLogos[program.shortName || ''] || getProgramImage(program.shortName || '')" alt="program logo" />
                </div>
              </ion-item>

              <ion-list slot="content" class="bg-transparent" lines="none">
                <ion-item class="release-item add-playlist-button" @click="addPlayList(program.programName)"
                  v-show="!globalContext.offlineMode" color="violet">
                  <ion-label class="ion-text-center">+</ion-label>
                </ion-item>

                <ion-item-sliding name="itemSliding-all" v-for="(playlist, playlistIdx) in playlistsByPrograms[
                  program.shortName || ''
                ]" :key="playlistIdx">
                  <ion-item class="release-item" :detail="true" color="violet">
                    <ion-icon v-if="playlist.offline" slot="start" :icon="checkmarkCircle" color="success" class="offline-indicator"></ion-icon>
                    <ion-label class="ion-text-center" @click="openPlaylist(playlist.id)">{{ playlist.name }}</ion-label>
                  </ion-item>
                  <ion-item-options side="start">
                    <ion-item-option color="success" @click="copyPlaylist(playlist)">
                      <ion-icon slot="icon-only" :icon="copy"></ion-icon>
                    </ion-item-option>
                  </ion-item-options>
                  <ion-item-options side="end"
                    @ionSwipe="addToFavourites(playlist.id, playlist.favourite ? false : true)">
                    <ion-item-option @click="changePlaylist(playlist.id)" color="warning" v-show="!playlist.isRelease">
                      <ion-icon :icon="createOutline"></ion-icon>
                    </ion-item-option>
                    <ion-item-option color="danger" @click="confirmRemovement(playlist.id)"><ion-icon
                        :icon="trashOutline"></ion-icon></ion-item-option>
                    <ion-item-option @click="addToFavourites(playlist.id, true)" color="success"
                      v-show="!playlist.favourite" expandable>
                      <ion-icon :icon="starOutline"></ion-icon>
                    </ion-item-option>
                    <ion-item-option @click="addToFavourites(playlist.id, false)" color="success"
                      v-show="playlist.favourite" class="white-icon" expandable>
                      <ion-icon :icon="star"></ion-icon>
                    </ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-accordion>
          </div>
        </ion-accordion-group>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>

        <ion-modal :is-open="showEditPlaylist" @willDismiss="closeTrackPreview()">
          <ion-content class="playlist-container" :scroll-y="false">
            <ion-header mode="md">
              <ion-toolbar>
                <ion-title class="playlist-name">{{
                  editPlaylist.name !== ""
                  ? editPlaylist.name
                  : "Новый плейлист"
                }}</ion-title>
                <ion-buttons slot="primary">
                  <ion-button class="playlist-header-button" @click="savePlaylist()">Сохранить</ion-button>
                  <ion-button class="playlist-header-button" @click="closeEditPlaylist()">
                    Закрыть
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-header>
            <ion-list lines="none" class="ion-margin-top">
              <ion-item class="ion-margin-start ion-margin-end">
                <ion-label>Название</ion-label>
                <ion-input type="text" v-model="editPlaylist.name" class="playlist-name-input"></ion-input>
              </ion-item>

              <ion-item class="ion-margin-start ion-margin-end">
                <ion-label>Программа</ion-label>
                <ion-select :value="selectedProgram.programName" v-model="selectedProgram" interface="popover" mode="ios"
                  :interface-options="customPopoverOptions" @ionChange="programChanged()">
                  <ion-select-option v-for="program in programs" :key="program.shortName" :value="program">{{
                    program.programName }}</ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item v-show="selectedProgram.programName !== ''" class="ion-margin-start ion-margin-end">
                <ion-label>Релиз</ion-label>
                <ion-select :value="selectedRelease" v-model="selectedRelease" interface="popover" mode="ios"
                  :interface-options="customPopoverOptions" @ionChange="releaseChanged()">
                  <ion-select-option v-for="(release, idx) in getProgramReleases(
                    selectedProgram.programName
                  )" :key="idx" :value="release">{{ release }}</ion-select-option>
                </ion-select>
              </ion-item>


              <div :class="[
                'add-button-container',
                releaseTracksVisible ? 'danger-background' : '',
              ]" v-show="selectedRelease !== ''">
                <ion-button @click="showReleaseTracks()">
                  <ion-icon slot="icon-only" :icon="add" :class="[releaseTracksVisible ? 'close-button' : '']"></ion-icon>
                </ion-button>
              </div>

              <ion-list lines="none" class="playlist-content ion-margin-bottom" v-show="releaseTracksVisible">
                <ion-list-header>
                  <ion-label class="playlist-header-label">{{
                    `${selectedProgram.programName} - ${selectedRelease}`
                  }}</ion-label>
                  <ion-label>{{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDuration(selectedTracks)
                    )
                  }}</ion-label>
                </ion-list-header>

                <ion-content :forceOverscroll="true">
                  <ion-item v-for="(track, idx) in musicList" :key="idx" class="preview-item">
                    <div v-show="track.id == previewTrackId" class="preview-progress" :style="{
                      width: `${(previewCurrentPosition / previewDuration) * 100
                        }%`,
                    }"></div>
                    <ion-icon @click="previewTrack(track)" slot="start" :icon="previewPlaying && track.id == previewTrackId
                        ? pause
                        : play
                      " class="play-button" v-show="!previewLoading || track.id !== previewTrackId"></ion-icon>
                    <ion-spinner slot="start" name="bubbles"
                      v-show="track.id == previewTrackId && previewLoading"></ion-spinner>
                    <ion-label>{{ mediaUtils.getTrackName(track) }}</ion-label>
                    <ion-label slot="end">{{
                      mediaUtils.formatTime(track.duration)
                    }}</ion-label>
                    <ion-icon slot="end" :icon="add" @click="addTrack(track)" :class="[
                      isAdded(track)
                        ? 'close-button danger-button'
                        : 'add-button',
                    ]"></ion-icon>
                  </ion-item>
                  <ion-item class="fake-footer bg-transparent" lines="none"></ion-item>
                </ion-content>
              </ion-list>

              <ion-list lines="none" class="playlist-content ion-margin-bottom" v-show="!releaseTracksVisible">
                <ion-list-header>
                  <ion-label class="playlist-header-label">Треки</ion-label>
                  <ion-label>{{
                    mediaUtils.formatTime(
                      mediaUtils.getTotalPlaylistDuration(selectedTracks)
                    )
                  }}</ion-label>
                </ion-list-header>

                <ion-text v-show="selectedRelease == ''" class="ion-margin-start">
                  Выберите программу и релиз
                </ion-text>

                <ion-content :forceOverscroll="true">
                  <ion-reorder-group @ionItemReorder="reorderPlaylist($event)" :disabled="false">
                    <ion-item-sliding v-for="track in selectedTracks" :key="track.id">
                      <ion-item>
                        <ion-reorder slot="start"></ion-reorder>
                        <ion-label>{{
                          mediaUtils.getTrackName(track)
                        }}</ion-label>
                        <ion-label slot="end">{{
                          mediaUtils.formatTime(track.duration)
                        }}</ion-label>
                      </ion-item>
                      <ion-item-options side="end">
                        <ion-item-option @click="removeTrack(track)" color="danger">
                          <ion-icon :icon="trashOutline"></ion-icon>
                        </ion-item-option>
                      </ion-item-options>
                    </ion-item-sliding>
                  </ion-reorder-group>
                  <ion-item class="fake-footer bg-transparent" lines="none"></ion-item>
                </ion-content>
              </ion-list>
            </ion-list>
          </ion-content>
        </ion-modal>
      </ion-content>

      <ion-content class="bg-transparent favourites-content" v-show="selectedListSegment == 'favourites'">
        <div v-for="(program, programIdx) in programs" :key="programIdx">
          <ion-list slot="content" class="bg-transparent" lines="none">
            <div v-for="(playlist, playlistIdx) in playlistsByPrograms[
              program.shortName || ''
            ]" :key="playlistIdx">
              <ion-item-sliding v-if="playlist.favourite" name="itemSliding-favourites">
                <ion-item class="release-item release-favourite-item" :detail="true" color="violet">
                  <ion-label class="ion-text-center" @click="openPlaylist(playlist.id)">{{ `${playlist.programName} -
                                      ${playlist.name}` }}</ion-label>
                </ion-item>
                <ion-item-options side="start">
                  <ion-item-option color="success" @click="copyPlaylist(playlist)">
                    <ion-icon slot="icon-only" :icon="copy"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
                <ion-item-options side="end" @ionSwipe="addToFavourites(playlist.id, playlist.favourite ? false : true)">
                  <ion-item-option @click="changePlaylist(playlist.id)" color="warning" v-show="!playlist.isRelease">
                    <ion-icon :icon="createOutline"></ion-icon>
                  </ion-item-option>
                  <ion-item-option color="danger" @click="confirmRemovement(playlist.id)"><ion-icon
                      :icon="trashOutline"></ion-icon></ion-item-option>
                  <ion-item-option @click="addToFavourites(playlist.id, true)" color="success"
                    v-show="!playlist.favourite" expandable>
                    <ion-icon :icon="starOutline"></ion-icon>
                  </ion-item-option>
                  <ion-item-option @click="addToFavourites(playlist.id, false)" color="success"
                    v-show="playlist.favourite" expandable>
                    <ion-icon :icon="star"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            </div>
          </ion-list>
        </div>
        <ion-item class="bg-transparent fake-item" lines="none"></ion-item>
      </ion-content>

      <ion-loading cssClass="liga-loading" spinner="lines" :is-open="isSavingRef" message="Сохранение...">
      </ion-loading>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { GoogleMedia } from "@/model/googlemedia.model";
import { MediaProgressBar } from "@/model/mediaprogressbar.model";
import { PlayerBar } from "@/model/playerbar.model";
import { Playlist } from "@/model/playlist.model";
import { Program } from "@/model/program.model";
import FilesystemCustomUtils from "@/services/filesystem.custom.utils";
import LogoService from "@/services/logo.service";
import MediaUtils from "@/services/media.utils";
import UnicodeUtils from "@/services/unicode.utils";
import { CapacitorHttp } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
    IonAccordion,
    IonAccordionGroup,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonLabel,
    IonList,
    IonListHeader,
    IonLoading,
    IonModal,
    IonPage,
    IonReorder,
    IonReorderGroup,
    IonSegment,
    IonSegmentButton,
    IonSelect,
    IonSelectOption,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    alertController,
    isPlatform,
} from "@ionic/vue";
import axios from "axios";
import { RmxAudioPlayer } from "capacitor-plugin-playlist";
import dayjs from "dayjs";
import {
    add,
    checkmarkCircle,
    close,
    copy,
    createOutline,
    pause,
    play,
    star,
    starOutline,
    trashOutline,
} from "ionicons/icons";
import { defineComponent, inject, ref } from "vue";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";
import PageHeaderWithMenu from "@/components/PageHeaderWithMenu.vue";

export default defineComponent({
  name: "PlaylistList",
  components: {
    PageHeaderWithMenu,
    IonContent,
    IonPage,
    IonAccordionGroup,
    IonAccordion,
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
    IonModal,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonButton,
    IonIcon,
    IonText,
    IonReorderGroup,
    IonReorder,
    IonHeader,
    IonTitle,
    IonButtons,
    IonToolbar,
    IonLoading,
    IonSpinner,
    IonSegment,
    IonSegmentButton,
  },
  setup() {
    const globalContext = inject("globalContext") as GlobalContext;
    const PLAYLISTS_DIRECTORY = "playlists";
    const PROGRAMS_PATH = "programs.json";
    const PLAYLIST_PATH = "playlist.json";

    const playerBar = inject("playerBar") as PlayerBar;
    const audioPlayer = inject("audioPlayer") as RmxAudioPlayer;
    const emitter = inject("emitter") as MittEmitter;
    const unicodeUtils = new UnicodeUtils();
    const mediaUtils = new MediaUtils();
    const filesystemCustomUtils = new FilesystemCustomUtils();

    const customPopoverOptions: any = {
      cssClass: "month-selector",
    };

    const isSavingRef = ref(false);
    const setSaving = (state: boolean) => {
      isSavingRef.value = state;
    };

    return {
      globalContext,
      PLAYLISTS_DIRECTORY,
      PROGRAMS_PATH,
      PLAYLIST_PATH,
      audioPlayer,
      add,
      checkmarkCircle,
      close,
      trashOutline,
      createOutline,
      play,
      pause,
      copy,
      playerBar,
      emitter,
      customPopoverOptions,
      unicodeUtils,
      mediaUtils,
      setSaving,
      isSavingRef,
      filesystemCustomUtils,
      starOutline,
      star,
    };
  },
  data() {
    return {
      playlists: Array<Playlist>(),
      musicList: Array<GoogleMedia>(),
      programs: Array<Program>(),
      showEditPlaylist: false,
      releaseTracksVisible: false,
      editPlaylist: new Playlist("", "", ""),
      selectedProgram: new Program(0, "", "", "", false, [], []),
      selectedRelease: "",
      selectedTracks: Array<GoogleMedia>(),
      selectedPlaylist: new Playlist("", "", ""),
      downloaded: 0,
      downloading: false,
      downloadProgressBar: new MediaProgressBar(),
      previewTrackId: "",
      previewTrackPath: "",
      selectedListSegment: "all",
      programLogos: {} as Record<string, string>,
      logoService: new LogoService(),
      headerScrolled: false,
    };
  },

  computed: {
    playlistsByPrograms(): any {
      return this.groupBy(this.playlists, "programShortName");
    },

    musicDirectory(): string {
      return `${this.selectedProgram.shortName +
        "_" +
        (this.selectedRelease.length === 1
          ? "0" + this.selectedRelease
          : this.selectedRelease) +
        "_Music"
        }`;
    },

    previewLoading(): boolean {
      return !this.playerBar.isReady;
    },
    previewPlaying(): boolean {
      return this.playerBar.playing || false;
    },
    previewDuration(): number {
      return this.playerBar.currentDuration;
    },
    previewCurrentPosition(): number {
      return this.playerBar.currentPosition;
    },
  },

  ionViewWillEnter() {
    this.getAllPlaylists();
    this.getPrograms();
  },

  methods: {
    onContentScroll(e: CustomEvent) {
      const scrollTop = (e.target as HTMLElement)?.scrollTop ?? 0;
      (this as { headerScrolled: boolean }).headerScrolled = scrollTop > 16;
    },
    closeSliding() {
      const itemSliding = document.getElementsByName(`itemSliding-${this.selectedListSegment}`);
      for (let i = 0; i < itemSliding.length; i++) {
        (itemSliding[i] as any).closeOpened();
      }
    },

    listSegmentChange(event: CustomEvent): void {
      this.selectedListSegment = event.detail.value;
    },

    async previewTrack(track: GoogleMedia): Promise<void> {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      if (this.audioPlayer && this.audioPlayer.isPlaying) {
        this.audioPlayer.pause();
      } else if (this.previewTrackId == track.id && this.audioPlayer && this.audioPlayer.hasLoaded && this.audioPlayer.isPaused) {
        this.audioPlayer.play();
      }

      if (this.previewTrackId !== track.id) {
        this.previewTrackId = track.id;
        
        // Check if track is from server (path starts with "releases/")
        const isServerTrack = track.id.startsWith('releases/');

        if (isServerTrack) {
          // Use server API for releases
          const options = {
            url: `${process.env.VUE_APP_API_URL}api/releases/stream-request?path=${encodeURIComponent(track.id)}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          CapacitorHttp.get(options)
            .then((response) => {
              if (response.data && response.data.streamUrl) {
                this.previewTrackPath = response.data.streamUrl;
              } else {
                // Fallback to direct streaming
                this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/releases/stream?path=${encodeURIComponent(track.id)}`;
              }
            })
            .catch(() => {
              // Fallback to direct streaming on error
              this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/releases/stream?path=${encodeURIComponent(track.id)}`;
            })
            .finally(() => {
              if (this.audioPlayer) {
                this.audioPlayer.setPlaylistItems([
                  {
                    isStream: false,
                    trackId: this.previewTrackId,
                    assetUrl: this.previewTrackPath,
                    artist: "Liga.Team",
                    albumArt: '',
                    album: `${this.selectedProgram.programName} - ${this.selectedRelease}`,
                    title: this.mediaUtils.getTrackName(track),
                  }
                ],
                  {
                    playFromPosition: 0,
                    playFromId: this.previewTrackId,
                    startPaused: false
                  });
              }
            });
        } else {
          // Original Google Drive logic
          this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${track.id}`;

          const options = {
            url: `${process.env.VUE_APP_API_URL
              }api/google/media/storage/${this.previewTrackId}.${this.filesystemCustomUtils.mimeExtensions.get(
                track.mimeType
              )}`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          CapacitorHttp.get(options)
            .then((response) => {
              if (response.data) {
                this.previewTrackPath = `${process.env.VUE_APP_MEDIA_URL
                  }media/${this.previewTrackId}.${this.filesystemCustomUtils.mimeExtensions.get(
                    track.mimeType
                  )}`;
              } else {
                this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${this.previewTrackId}`;
              }
            })
            .catch(() => {
              this.previewTrackPath = `${process.env.VUE_APP_API_URL}api/google/music/${this.previewTrackId}`;
            }).finally(() => {
              if (this.audioPlayer) {
                this.audioPlayer.setPlaylistItems([
                  {
                    isStream: false,
                    trackId: this.previewTrackId,
                    assetUrl: this.previewTrackPath,
                    artist: "Liga.Team",
                    albumArt: '',
                    album: `${this.selectedProgram.programName} - ${this.selectedRelease}`,
                    title: this.mediaUtils.getTrackName(track),
                  }
                ],
                  {
                    playFromPosition: 0,
                    playFromId: this.previewTrackId,
                    startPaused: false
                  });
              }
            });
        }
      }
    },

    closeTrackPreview(): void {
      if (this.audioPlayer) {
        this.audioPlayer.pause();
      }
      this.previewTrackId = "";
    },

    async loadProgramLogos() {
      const loadPromises = this.programs.map(async (program: Program) => {
        if (program.shortName) {
          try {
            const logoUrl = await this.logoService.getProgramLogo(program.shortName);
            this.programLogos[program.shortName] = logoUrl;
          } catch (error) {
            console.error(`Failed to load logo for ${program.shortName}:`, error);
          }
        }
      });
      
      await Promise.allSettled(loadPromises);
    },

    getProgramImage(shortName: string): string {
      if (!shortName || shortName.trim() === '') {
        return require('@/theme/liga-logo-white.png');
      }
      
      try {
        return require(`@/theme/programs/${shortName}.png`);
      } catch (error) {
        console.warn(`Program image not found for ${shortName}, using Liga logo as fallback`);
        return require('@/theme/liga-logo-white.png');
      }
    },

    async getPrograms() {
      if (this.globalContext.offlineMode) {
        //try to load local programs
        Filesystem.readFile({
          path: `${this.PLAYLISTS_DIRECTORY}/${this.PROGRAMS_PATH}`,
          directory: Directory.Data,
          encoding: Encoding.UTF8,
        })
          .then((programsFile) => {
            this.programs = JSON.parse(typeof programsFile.data === 'string' ? programsFile.data : '');
            this.loadProgramLogos();
          })
          .catch((err) => {
            console.error("Failed to load local programs list", err);
          });
        return;
      }

      if (isPlatform("ios") || isPlatform("android")) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/programs-with-releases`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.programs = response.data;
            this.filesystemCustomUtils.storeFile(
              (JSON.stringify(this.programs)),
              this.PROGRAMS_PATH,
              this.PLAYLISTS_DIRECTORY
            );
            this.loadProgramLogos();
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      } else {
        axios
          .get("/api/programs-with-releases")
          .then((response) => {
            this.programs = response.data;
            this.loadProgramLogos();
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    getProgramReleases(programName?: string): string[] {
      if (!programName) return [];

      const filteredProgram = this.programs.filter((program) => {
        return program.programName == programName;
      });

      if (
        null != filteredProgram &&
        filteredProgram.length > 0 &&
        filteredProgram[0].releases
      ) {
        return filteredProgram[0].releases
          .map((r) => {
            return r.length > 1 ? r : `0${r}`;
          })
          .sort();
      }

      return [];
    },

    getAllPlaylists() {
      if (isPlatform("ios") || isPlatform("android")) {
        this.playlists = new Array<Playlist>();
        Filesystem.readdir({
          path: this.PLAYLISTS_DIRECTORY,
          directory: Directory.Data,
        })
          .then((playlistDirs) => {
            for (let i = 0; i < playlistDirs.files.length; i++) {
              Filesystem.readdir({
                path: `${this.PLAYLISTS_DIRECTORY}/${playlistDirs.files[i].name}`,
                directory: Directory.Data,
              })
                .then((res) => {
                  const foundPlaylist = res.files.find((f) => {
                    return f.name == this.PLAYLIST_PATH;
                  });

                  if (
                    typeof foundPlaylist !== "undefined" &&
                    null != foundPlaylist
                  ) {
                    Filesystem.readFile({
                      path: `${this.PLAYLISTS_DIRECTORY}/${playlistDirs.files[i].name}/${this.PLAYLIST_PATH}`,
                      directory: Directory.Data,
                      encoding: Encoding.UTF8,
                    })
                      .then((res) => {
                        const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                        if (!localPlaylist) throw new Error("Local playlist is null");

                        const filesystemCustomUtils =
                          new FilesystemCustomUtils();
                        filesystemCustomUtils
                          .isPlaylistOffline(
                            this.PLAYLISTS_DIRECTORY,
                            localPlaylist
                          )
                          .then((response) => {
                            localPlaylist.offline = response;
                            this.playlists.push(localPlaylist);
                          });
                      })
                      .catch((err) => {
                        console.error("Failed to load local playlist", err);
                      });
                  }
                })
                .catch(() => {
                  // not exists or not a dir
                });
            }
          })
          .catch(() => {
            // not exists
          });
      } else {
        this.playlists = new Array<Playlist>();
      }

      this.playlists.sort((a, b) => {
        let bySortIdx = 0;
        if (a.sortIdx > b.sortIdx) bySortIdx = -1;
        if (a.sortIdx > b.sortIdx) bySortIdx = 1;

        let byProgram = 0;
        if (a.programShortName > b.programShortName) byProgram = -1;
        if (a.programShortName > b.programShortName) byProgram = 1;

        let byName = 0;
        if (a.name > b.name) byName = -1;
        if (a.name > b.name) byName = 1;

        return byProgram || bySortIdx || byName;
      });

      this.playlists.forEach((playlistItem, index) => {
        playlistItem.sortIdx = index;
      });
    },

    addPlayList(programName?: string) {
      if (!programName) return;

      this.showEditPlaylist = true;
      const found = this.programs.find((p) => {
        return p.programName === programName;
      });
      if (typeof found !== "undefined" && found !== null) {
        this.selectedProgram = found;
      }
    },

    willPresentEditPlaylist() {
      //clear fields
      this.selectedRelease = "";
      this.releaseTracksVisible = false;
    },

    didDismissEditPlaylist() {
      this.closeEditPlaylist();
    },

    closeEditPlaylist() {
      this.showEditPlaylist = false;
      //clear fields
      this.selectedTracks = new Array<GoogleMedia>();
      this.editPlaylist = new Playlist("", "", "");
    },

    programChanged() {
      this.releaseTracksVisible = false;
      this.selectedRelease = "";
      this.closeTrackPreview();
    },

    releaseChanged() {
      this.closeTrackPreview();
      this.musicList = new Array<GoogleMedia>();
      if (this.selectedRelease !== "") {
        this.getMusicList();
      }
    },

    showReleaseTracks() {
      this.releaseTracksVisible = !this.releaseTracksVisible;
      if (!this.releaseTracksVisible) {
        this.closeTrackPreview();
      }
    },

    async getMusicList() {
      // First, get release info to check contentSource
      let releaseEntity = null;
      
      // Find the release ID based on selected program and release number
      const program = this.programs.find(p => p.programName === this.selectedProgram.programName);
      if (program && program.fullReleases) {
        releaseEntity = program.fullReleases.find((r: any) => {
          const releaseWithZero = r.releaseName.length === 1 ? '0' + r.releaseName : r.releaseName;
          return releaseWithZero === this.selectedRelease;
        });
      }
      
      // Check if release uses server storage
      if (releaseEntity && releaseEntity.contentSource === 'SERVER') {
        // Use server API
        if (isPlatform("ios") || isPlatform("android")) {
          const tokenQuery = await Preferences.get({ key: "jwt" });
          const token = tokenQuery.value;

          const options = {
            url: `${process.env.VUE_APP_API_URL}api/releases/${releaseEntity.id}/media/music`,
            headers: { Authorization: `Bearer ${token}` },
            readTimeout: 60000,
          };

          await CapacitorHttp.get(options)
            .then((response) => {
              this.musicList = response.data;
            })
            .catch(() => {
              this.$router.replace("/badconnection");
            });
        } else {
          axios
            .get(`/api/releases/${releaseEntity.id}/media/music`)
            .then((response) => {
              this.musicList = response.data;
            })
            .catch((err) => {
              console.log("call error " + err);
            });
        }
        return;
      }
      
      // Original Google Drive logic (for backward compatibility)
      if (isPlatform("ios") || isPlatform("android")) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/google/media/${this.musicDirectory}`,
          headers: { Authorization: `Bearer ${token}` },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.musicList = response.data;
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      } else {
        axios
          .get(`/api/google/media/${this.musicDirectory}`)
          .then((response) => {
            this.musicList = response.data;
          })
          .catch((err) => {
            console.log("call error " + err);
          });
      }
    },

    addTrack(track: GoogleMedia): void {
      if (this.isAdded(track)) {
        this.removeTrack(track);
      } else {
        this.selectedTracks.push(track);
      }
    },
    removeTrack(track: GoogleMedia): void {
      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.removeFromDownloadedPlaylist(
        this.editPlaylist,
        track
      );

      this.selectedTracks = this.selectedTracks.filter((t) => {
        return t.id !== track.id;
      });
    },
    isAdded(track: GoogleMedia): boolean {
      const found = this.selectedTracks.find((t) => {
        return t.id === track.id;
      });
      return typeof found !== "undefined" && null !== found;
    },

    savePlaylist() {
      if (this.editPlaylist.name === "") {
        this.showAlert("Ошибка", "Укажите название плейлиста");
        return;
      }

      this.editPlaylist.programName = this.selectedProgram.programName || "";
      this.editPlaylist.programShortName = this.selectedProgram.shortName || "";
      this.editPlaylist.tracks = this.selectedTracks;
      if (
        typeof this.editPlaylist.id == "undefined" ||
        "" == this.editPlaylist.id
      ) {
        this.editPlaylist.id = `${this.selectedProgram.shortName
          }_${dayjs().day()}${dayjs().hour()}${dayjs().minute()}${dayjs().millisecond()}`;
      }
      this.editPlaylist.offline = false;

      const savingPlaylist = this.editPlaylist;
      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(this.editPlaylist)),
        this.PLAYLIST_PATH,
        `${this.PLAYLISTS_DIRECTORY}/${this.editPlaylist.id}`
      ).then((storeResult) => {
        if (storeResult && !this.globalContext.offlineMode) {
          Preferences.get({ key: "jwt" }).then((tokenQuery) => {
            CapacitorHttp.get({
              url: `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${this.selectedProgram.shortName}.png`,
              headers: { Authorization: `Bearer ${tokenQuery.value}` },
              readTimeout: 60000,
            }).then((response) => {
              Filesystem.writeFile({
                path: `${this.PLAYLISTS_DIRECTORY}/${savingPlaylist.id}/${this.selectedProgram.shortName}.png`,
                data: response.data,
                directory: Directory.Data
              });
            });
          });
        } else if (!this.editPlaylist.offline) {
          this.removeDownloadedPlaylist(savingPlaylist);
        }

        let currentIndex = -1;
        this.playlists.forEach((p, index) => {
          if (p.id === this.editPlaylist.id) {
            currentIndex = index;
          }
        });

        if (currentIndex > -1) {
          this.playlists[currentIndex] = this.editPlaylist;
        } else {
          this.playlists.push(this.editPlaylist);
        }

        // save id const to open it after clearing editPlaylist container
        const editPlaylistId = this.editPlaylist.id;

        this.closeEditPlaylist();

        this.openPlaylist(editPlaylistId);
      });
    },

    reorderPlaylist(event: CustomEvent) {
      const movingTrack = this.selectedTracks.splice(event.detail.from, 1)[0];
      this.selectedTracks.splice(event.detail.to, 0, movingTrack);
      event.detail.complete();
    },

    openPlaylist(playlistId: string) {
      this.openPlayListView(playlistId);
    },

    openPlayListView(playlistId: string) {
      const foundPlaylist = this.playlists.find((p) => {
        return p.id == playlistId;
      });

      if (typeof foundPlaylist === "undefined" || null === foundPlaylist) return;

      Preferences.set({
        key: "playlistMeta",
        value: JSON.stringify(foundPlaylist),
      }).then(() => {
        this.$router.push({
          name: "PlayListView",
        });
      });
    },

    addToFavourites(playlistId: string, favourite: boolean) {
      const savingPlaylist = this.playlists.find((p) => {
        return p.id === playlistId;
      });

      if (undefined === savingPlaylist || null === savingPlaylist) return;

      savingPlaylist.favourite = favourite;

      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(savingPlaylist)),
        this.PLAYLIST_PATH,
        `${this.PLAYLISTS_DIRECTORY}/${savingPlaylist.id}`
      );

      this.closeSliding();
    },

    changePlaylist(playlistId: string) {
      const editPlaylist = this.playlists.find((p) => {
        return p.id === playlistId;
      });

      if (undefined === editPlaylist || null === editPlaylist) return;

      this.selectedTracks = editPlaylist.tracks;

      const foundProgram = this.programs.find((p) => {
        return p.programName === editPlaylist.programName;
      });
      if (typeof foundProgram !== "undefined" && foundProgram !== null) {
        this.selectedProgram = foundProgram;
      }

      this.showEditPlaylist = true;
      this.editPlaylist = editPlaylist;

      this.closeSliding();
    },

    async confirmRemovement(playlistId: string) {
      const alert = await alertController.create({
        header: "Подтверждение!",
        message: "Точно удаляем?",
        buttons: [
          {
            text: "Отмена",
            role: "cancel",
            cssClass: "secondary",
            id: "cancel-button",
          },
          {
            text: "Да",
            id: "confirm-button",
            handler: () => {
              this.removePlaylist(playlistId);
            },
          },
        ],
      });
      return alert.present();
    },

    removePlaylist(playlistId: string) {
      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.removePlaylistDirectory(playlistId);

      this.playlists = this.playlists.filter((p) => {
        return p.id !== playlistId;
      });

      this.closeSliding();
    },

    copyPlaylist(playlist: Playlist) {
      const playlistCopy = new Playlist(
        `${playlist.name}_copy`,
        playlist.programName,
        playlist.programShortName
      );
      playlistCopy.id = `${playlist.programShortName
        }_${dayjs().day()}${dayjs().hour()}${dayjs().minute()}${dayjs().millisecond()}`;
      playlistCopy.tracks = playlist.tracks;
      playlistCopy.offline = false;

      this.filesystemCustomUtils.storeFile(
        this.unicodeUtils.toBase64(JSON.stringify(playlistCopy)),
        this.PLAYLIST_PATH,
        `${this.PLAYLISTS_DIRECTORY}/${playlistCopy.id}`
      )
        .then((storeResult) => {
          if (storeResult && !this.globalContext.offlineMode) {
            Preferences.get({ key: "jwt" }).then((tokenQuery) => {
              CapacitorHttp.get({
                url: `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${playlist.programShortName}.png`,
                headers: { Authorization: `Bearer ${tokenQuery.value}` },
                readTimeout: 60000,
              }).then((response) => {
                Filesystem.writeFile({
                  path: `${this.PLAYLISTS_DIRECTORY}/${playlistCopy.id}/${playlist.programShortName}.png`,
                  data: response.data,
                  directory: Directory.Data,
                });
              });

              CapacitorHttp.put({
                url: `${process.env.VUE_APP_API_URL}api/playlist`,
                headers: {
                  Authorization: `Bearer ${tokenQuery.value}`,
                  "Content-Type": "application/json",
                },
                data: {
                  name: playlistCopy.id,
                  content: (
                    JSON.stringify(playlistCopy)
                  ),
                },
              });
            });
          }

          this.playlists.push(playlistCopy);

          this.openPlaylist(playlistCopy.id);
        })
        .finally(() => {
          this.closeSliding();
        });
    },

    removeDownloadedPlaylist(playlist: Playlist) {
      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.removeDownloadedPlaylist(playlist);
      playlist.offline = false;
    },

    groupBy(xs: any, key: any) {
      return xs.reduce((rv: any, x: any) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },

    async getFsPermissions(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        Filesystem.checkPermissions().then((fsPermissions) => {
          if (fsPermissions.publicStorage.toString() !== "granted") {
            Filesystem.requestPermissions().then((requestFsPermissions) => {
              if (requestFsPermissions.publicStorage.toString() !== "granted") {
                resolve(false);
              } else {
                resolve(true);
              }
            });
          } else {
            resolve(true);
          }
        });
      });
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController.create({
        header: alertTitle,
        message: alertMessage,
        buttons: ["OK"],
      });

      await alert.present();
    },
  },
});
</script>

<style scoped>
h1 {
  letter-spacing: 0.08em;
}

.program-main {
  background-color: black;
  opacity: 0.9;
}

.program-item {
  --background: rgba(67, 67, 67, 0.7);
  color: white;
  --color-hover: white;
  font-weight: bold;
  --min-height: 100px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.program-img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.program-img-wrapper img {
  scale: 0.7;
  object-fit: scale-down;
}

.release-item {
  --background: rgba(134, 134, 134, 0.5);
  color: rgb(226, 226, 226);
  --min-height: 80px;
  font-weight: bold;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.release-item ion-label {
  font-family: 'Montserrat';
  color: white;
}

.release-favourite-item {
  border: unset !important;
  margin-bottom: 5px !important;
}

.favourites-content ion-item-option {
  margin-bottom: 5px !important;
}

.release-option {
  --background: var(--ion-color-orange);
}

.release-option ion-icon {
  color: white;
  scale: 1.5;
}

.release-container {
  position: relative;
}

.download-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 100;
  background: var(--ion-color-orange);
  opacity: 0.6;
}

.add-playlist-button {
  font-size: 2em;
  --min-height: 60px;
  border-bottom: 1px solid rgba(67, 67, 67, .5);
}

.playlist-container {
  --background: #1e1e1e !important;
}

.playlist-container ion-list {
  height: 100%;
  background: #1e1e1e !important;
}

.playlist-container ion-list-header {
  font-size: 1.5em;
  font-weight: bold;
  color: white;
}

.playlist-name {
  color: white !important;
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.playlist-name-input {
  font-family: 'Montserrat';
}

.playlist-header-label {
  color: white !important;
  width: 50%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.playlist-header-icon {
  font-size: 0.8em;
  color: white;
}

.playlist-header-button {
  color: white !important;
  --color: white !important;
  --background-activated: transparent !important;
  --border-color: var(--ion-color-orange);
}

.playlist-header-button ion-icon {
  font-size: 1.5em;
  margin-bottom: 3px;
  color: white !important;
}

.remove-download-button {
  font-size: 0.8em !important;
}

.column-buttons {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-flow: column;
}

.download-button {
  display: flex;
  width: 100%;
  justify-content: center;
}

.download-button ion-button {
  --border-width: 0 !important;
}

.playlist-container ion-item {
  --background: #343434;
  --border-radius: 5px;
  color: white;
  margin-bottom: 5px;
}

.playlist-container ion-label {
  color: white;
}

.playlist-content ion-content {
  max-height: 50vh !important;
  --background: #1e1e1e;
}

.playlist-content ion-label {
  color: white !important;
}

.playlist-content ion-item {
  color: white !important;
  --border-radius: 0 !important;
  margin-bottom: 2px !important;
}

.playlist-content ion-item-option {
  margin-bottom: 2px !important;
}

.add-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.add-button-container ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 50px;
  height: 50px;
  --border-radius: 25px;
}

.close-button {
  transform: rotateZ(45deg);
}

.add-button {
  color: #c0c0be;
}

.play-button {
  color: #c0c0be;
}

.preview-item {
  position: relative;
}

.preview-progress {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: var(--ion-color-orange);
}

.danger-button {
  color: var(--ion-color-danger);
}

.danger-background ion-button {
  --background: var(--ion-color-danger) !important;
}

.playlist-fake-item {
  --background: transparent !important;
}

ion-modal {
  --background: #1e1e1e;
}

ion-toolbar {
  --background: #1e1e1e;
}

ion-text {
  color: white;
}

.program-img-wrapper {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
}

.download-progress-bar {
  height: 5px;
  --progress-background: var(--ion-color-orange);
  --background: #c0c0be;
}

.offline-toggle {
  --background: white;
  --background-checked: var(--ion-color-orange);
  --handle-background: white;
  --handle-background-checked: white;
}

.playlist-total-duration {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 1.5em;
  font-weight: bold;
}

.fake-footer {
  height: 20vh;
}

.offline-indicator {
  font-size: 1.2em;
  margin-right: 8px;
}

ion-item::part(detail-icon) {
  color: white;
}
</style>